import type { CapitalGlobalCoverageCatalogItem } from '@/features/quotes/schemas/capital-global/coverages-catalog';

export type CoverageCategorySection = {
  category: string;
  items: CapitalGlobalCoverageCatalogItem[];
};

/** Coberturas sem categoria no catálogo caem nesta seção. */
const FALLBACK_CATEGORY_LABEL = 'Outras coberturas';

/** Título usado quando NENHUMA cobertura traz categoria (catálogo antigo). */
const SINGLE_SECTION_LABEL = 'Coberturas';

/**
 * Agrupa o catálogo de coberturas por categoria oficial do InsureMO
 * (`CoverageCategory_CodeDesc`), preservando a ordem de aparição — o catálogo
 * já chega ordenado por `sequence`. Mesma regra do Step Plano do PME.
 *
 * Quando o produto ainda não traz categoria em nenhuma cobertura, devolve uma
 * seção única "Coberturas" (comportamento anterior à categorização).
 */
export function groupCatalogByCategory(
  catalog: CapitalGlobalCoverageCatalogItem[]
): CoverageCategorySection[] {
  const order: string[] = [];
  const byCategory = new Map<string, CapitalGlobalCoverageCatalogItem[]>();

  for (const item of catalog) {
    const category = item.category?.trim() || FALLBACK_CATEGORY_LABEL;
    if (!byCategory.has(category)) {
      byCategory.set(category, []);
      order.push(category);
    }
    byCategory.get(category)!.push(item);
  }

  if (order.length === 1 && order[0] === FALLBACK_CATEGORY_LABEL) {
    return [{ category: SINGLE_SECTION_LABEL, items: catalog }];
  }

  return order.map(category => ({
    category,
    items: byCategory.get(category)!,
  }));
}
